// This file is auto-generated by @hey-api/openapi-ts

export const CompanyCardApplicationStateEnum = {
    REJECTED: 'REJECTED',
    PROCESSED: 'PROCESSED',
    APPROVED: 'APPROVED',
    UNPROCESSED: 'UNPROCESSED'
} as const;

export type CompanyCardApplicationStateEnum = typeof CompanyCardApplicationStateEnum[keyof typeof CompanyCardApplicationStateEnum];
